import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'
import { getInterest } from 'ducks/respondent'
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar'

const InterestBar = ({ totalAnswers, totalQuestions }) => (
  <ProgressBar
    timeLabel={t`Unlimited time`}
    totalAnswers={totalAnswers}
    totalQuestions={totalQuestions}
  />
)

const mapStateToProps = state => {
  const { totalAnswers, totalQuestions } = getInterest(state)

  return {
    totalAnswers,
    totalQuestions,
  }
}

export default connect(mapStateToProps)(InterestBar)
